import { Button } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { DownloadOutlined } from '@ant-design/icons';

function FinancialTable({ financeData, graphKey, countKey, checkboxes }) {
  const [columnData, setColumnData] = useState([
    "app",
    "crm",
    "web_native",
    "web_shopify",
  ]);

  const mappedData = [
    "Total Orders",
    "Male Orders",
    "Female Orders",
    "Repeat Orders",
    "New Orders",
    "Male Repeat Order",
    "Male New Order",
    "Female Repeat Order",
    "Female New Order",
  ];

  const groups = [
    ["totalOrdersCount", "totalOrdersSum"],
    ["maleOrdersCount", "maleOrdersSum"],
    ["femaleOrdersCount", "femaleOrdersSum"],
    ["repeatOrdersCount", "repeatOrdersSum"],
    ["newOrdersCount", "newOrdersOrdersSum"],
    ["maleRepeatOrderCount", "maleRepeatOrderSum"],
    ["maleNewOrderCount", "maleNewOrderSum"],
    ["femaleRepeatOrderCount", "femaleRepeatOrderSum"],
    ["femaleNewOrdersCount", "femaleNewOrderSum"],
  ];
  
  const hoursArray = Array.from({ length: 24 }, (_, index) => {
    const hour = index === 0 ? 12 : index;
    const period = index < 12 ? "am" : "pm";
    return `${hour} ${period}`;
  });

  useEffect(() => {
    const checkedArray = [];
    for (let key in checkboxes) {
      if (checkboxes[key]) {
        checkedArray.push(key);
      }
    }
    setColumnData(checkedArray);
  }, [checkboxes]);


  function downloadExcel() {
    const rows = [];
    const headerRow = [
      "Source",
      "Key",
      ...hoursArray,
    ];
    rows.push(headerRow);
    columnData.forEach((item) => {
      mappedData.forEach((key, keyIndex) => {
        const row = [item, key];
        for (let i = 0; i < 24; i++) {
          const todayCountValue = get(
            financeData?.today?.[i]?.[item],
            [groups[keyIndex][0]],
            0
          );
          const todaySumValue = get(
            financeData?.today?.[i]?.[item],
            [groups[keyIndex][1]],
            0
          );
          const yesterdayCountValue = get(
            financeData?.yesterday?.[i]?.[item],
            [groups[keyIndex][0]],
            0
          );
          const yesterdaySumValue = get(
            financeData?.yesterday?.[i]?.[item],
            [groups[keyIndex][1]],
            0
          );
          row.push(`Today: ${todayCountValue} | ${todaySumValue} --- Yesterday: ${yesterdayCountValue} | ${yesterdaySumValue}`);
        }
        rows.push(row);
      });
    });

    const csvContent = rows.map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "FinancialData.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <>
      <div className="text-end mt-n2 mb-2">
      <Button type="primary" icon={<DownloadOutlined />} shape="round" size={'small'} onClick={downloadExcel}>Download</Button>
      </div>

      <div className="scrollable-table scrollable-container rounded">
        <table className="table table-responsive table-striped table-bordered border border-white table-hover shadow">
          <thead className="table-head">
            <tr className="table-head">
              <th
                style={{
                  minWidth: "10.5rem",
                  maxWidth: "10.5rem",
                  position: "sticky",
                  left: "0",
                  top: "0",
                  zIndex: "4",
                }}
                className="flex-1 align-top text-center bg-secondary text-white table-head"
              >
                <span className="h-100 w-100">Sources</span>
              </th>
              <th
                style={{
                  minWidth: "15.5rem",
                  maxWidth: "15.5rem",
                  position: "sticky",
                  left: "10.5rem",
                  top: "0",
                  zIndex: "4",
                }}
                className="flex-1 align-top text-center bg-secondary text-white table-head"
              >
                <span className="h-100 w-100">Keys</span>
              </th>
              {hoursArray?.map((field, index) => (
                <th
                  key={index}
                  style={{ position: "sticky", top: 0 }}
                  className="align-top text-center bg-secondary text-white  border  border"
                >
                  {field}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {columnData?.map((item, itemIndex) => {
              return (
                <tr key={itemIndex}>
                  <td
                    style={{
                      minWidth: "10.5rem",
                      maxWidth: "10.5rem",
                      position: "sticky",
                      left: "0",
                      zIndex: "1",
                      backgroundColor: "#C7D2E1",
                    }}
                    className="flex-1 align-top text-center cursor-pointer"
                  >
                    <span className="mt-5 fs-1 text-black fw-bold ">
                      {" "}
                      {item}
                    </span>
                  </td>
                  <td
                    style={{
                      minWidth: "15.5rem",
                      maxWidth: "15.5rem",
                      position: "sticky",
                      left: "10.5rem",
                      zIndex: "1",
                      backgroundColor: "#C7D2E1",
                    }}
                    className="flex-1 align-top text-center cursor-pointer"
                  >
                    <div className="mt-4">
                      <ul class="list-group list-group-flush list-unstyled mb-2">
                        {mappedData?.map((item, index) => {
                          return (
                            <>
                              <li style={{ borderBottom: "1px solid black" }}>
                                <div
                                  key={index}
                                  className="d-flex justify-content-between "
                                >
                                  <span className="text-end fw-bold text-black mb-2">
                                    {item}:
                                  </span>
                                </div>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </td>
                  {Array.from({ length: 24 }, (_, index) => {
                    const rowTodayData = financeData?.today?.[index]?.[item];
                    const rowYesterdayData =
                      financeData?.yesterday?.[index]?.[item];

                    const mappedTodayOrders = groups.map((group) =>
                      group.map((key) => ({
                        key: key,
                        value: rowTodayData[key],
                      }))
                    );

                    const mappedYesterdayOrders = groups.map((group) =>
                      group.map((key) => ({
                        key: key,
                        value: rowYesterdayData[key],
                      }))
                    );
                    return (
                      <td className="text-center ">
                        <div className="d-flex justify-content-between">
                          <div>
                            <div className="fw-bold text-black">Today</div>
                            <ul className="list-group list-group-flush list-unstyled mt-1">
                              {mappedTodayOrders?.map((item, index) => {
                                return (
                                  <li
                                    key={index}
                                    style={{ borderBottom: "1px solid black" }}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <span className="fw-bold ms-2 mb-2 text-nowrap">
                                        {get(item, ["0", "value"], 0)} |{" "}
                                        {get(item, ["1", "value"], 0)}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                          <div className="border mx-2"></div>
                          <div className="border-bottom">
                            <div className="fw-bold text-black">Yesterday</div>
                            <ul className="list-group list-group-flush list-unstyled mt-1">
                              {mappedYesterdayOrders?.map((item, index) => {
                                return (
                                  <li
                                    key={index}
                                    style={{ borderBottom: "1px solid black" }}
                                  >
                                    <div className="d-flex justify-content-between">
                                      <span className="fw-bold ms-2 mb-2 text-nowrap">
                                        {get(item, ["0", "value"], 0)} |{" "}
                                        {get(item, ["1", "value"], 0)}
                                      </span>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default FinancialTable;
